import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RequeststatusRoutingModule } from './requeststatus-routing.module';
import { RequestStatusActorListComponent } from '../../components/requeststatus/request-status-actor-list/request-status-actor-list.component';
import { RequestStatusUpdateDeadlineDateModal } from '../../modals/request-status-update-deadline-date.modal/request-status-update-deadline-date.modal';
import { RequeststatusdocumentslistComponent } from '../../components/requeststatus/requeststatusdocumentslist/requeststatusdocumentslist.component';
import { RequestStatusPersonDialogModal } from '../../components/requeststatus/requeststatuspersondialog/request-status-person-dialog.modal';
import { RequeststatustitleComponent } from '../../components/requeststatus/requeststatustitle/requeststatustitle.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AuthModule, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { OpenIdConfigService } from '../../services/openidconfig.service';
import { SharedModule } from '../shared/shared.module';
import { HttpClient } from '@angular/common/http';
import { isObservable, Observable } from 'rxjs';
import { WithdrawRequestModal } from '../../modals/withdraw-request/withdraw-request.modal';
import { AppComponent } from '../../components/app/app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RequestStatusUpdateDeadlineDaysModal } from 'src/app/modals/request-status-update-deadline-days.modal/request-status-update-deadline-days.modal';
import { MatTableModule } from '@angular/material/table';
import { RequeststatusPage } from 'src/app/components/requeststatus/requeststatus.page';
import { RequeststatusInfoComponent } from 'src/app/components/requeststatus/request-status-info/request-status-info.component';
import { StatusViewLogModal } from 'src/app/modals/status-view-log/status-view-log.modal';
import { StatusEditSendgroupNameModal } from 'src/app/modals/status-edit-sendgroup-name/status-edit-sendgroup-name.modal';
import { DesktopRequestStatusSendgroupListComponent, MobileRequestStatusSendgroupListComponent } from 'src/app/components/requeststatus/components/status-sendgroups/request-status-sendgroup-list.component';
import { DesktopRequestStatusSendgroupItemComponent, MobileRequestStatusSendgroupItemComponent } from 'src/app/components/requeststatus/components/status-sendgroups/request-status-sendgroup-item/request-status-sendgroup-item.component';
import { DesktopRequestStatusActionsByPersonComponent, MobileRequestStatusActionsByPersonComponent } from 'src/app/components/requeststatus/components/status-sendgroups/request-status-sendgroup-item/request-status-actions-by-person/request-status-actions-by-person.component';
import { DesktopRequestStatusSendgroupActionsComponent } from 'src/app/components/requeststatus/components/status-sendgroups/request-status-sendgroup-item/request-status-actions-by-person/request-status-sendgroup-action-row/desktop-request-status-sendgroup-action-row.component';
import { ChecklistRequestsComponent } from 'src/app/components/requeststatus/requeststatuspersondialog/checklist/checklist-requests.component';

const authFactory = (openIdConfigService: OpenIdConfigService) => {
  const config = openIdConfigService.getConfig();
  if (isObservable(config)) {
    return new StsConfigHttpLoader(<Observable<OpenIdConfiguration>>config);
  } else {
    return new StsConfigStaticLoader(<OpenIdConfiguration>config);
  }
};

@NgModule({
  declarations: [
    // The Page
    RequeststatusPage,
    // Components
    RequestStatusActorListComponent,
    DesktopRequestStatusSendgroupListComponent,
    MobileRequestStatusSendgroupListComponent,
    DesktopRequestStatusSendgroupItemComponent,
    MobileRequestStatusSendgroupItemComponent,
    MobileRequestStatusActionsByPersonComponent,
    DesktopRequestStatusActionsByPersonComponent,
    DesktopRequestStatusSendgroupActionsComponent,
    RequeststatustitleComponent,
    RequeststatusdocumentslistComponent,
    RequeststatusInfoComponent,
    // Modals
    StatusViewLogModal,
    StatusEditSendgroupNameModal,
    WithdrawRequestModal,
    RequestStatusPersonDialogModal,
    RequestStatusUpdateDeadlineDateModal,
    RequestStatusUpdateDeadlineDaysModal,
    ChecklistRequestsComponent,
  ],
  imports: [
    CommonModule,
    RequeststatusRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [OpenIdConfigService],
      }
    }),
    MatTableModule
  ],

  bootstrap: [AppComponent]

})
export class RequeststatusModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
